/////////////// LIB. ///////////////
////////////////////////////////////

// ...

////////////// UTIL. ///////////////
////////////////////////////////////

// ...

////////// EVENT HANDLERS //////////
////////////////////////////////////

// ...

////////////// ASSETS //////////////
////////////////////////////////////

const msgs = {
  start: ["init. flickity"],
  end: ["init. flickity", "init. success"],
};

//////// INIT. METHOD DEF. /////////
////////////////////////////////////

export default function init_flkty() {
  ////////////// Setup ///////////////
  ////////////////////////////////////

  const { wrpr_slides, slides, btn_prev, btn_next, paginationDots } = this.ref;
  const { logs } = this.options;
  if (logs) console.log(msgs.start[0]);

  /////// Height equalization ////////
  ////////////////////////////////////

  // Find the tallest slide
  let maxHeight = 0;
  slides.forEach((slide) => {
    const slideHeight = slide.offsetHeight;
    if (slideHeight > maxHeight) maxHeight = slideHeight;
  });

  // Set all slides to the max height
  slides.forEach((slide) => (slide.style.height = maxHeight + "px"));

  ////////// Flickity init. //////////
  ////////////////////////////////////

  const inst_flkty = new Flickity(wrpr_slides, {
    cellSelector: "[g-ref='slides']",
    wrapAround: false,
    cellAlign: "left",
    contain: false,
    pageDots: false,
    prevNextButtons: false,
    selectedAttraction: 0.01,
    friction: 0.2,
    draggable: true,
    imagesLoaded: true,
    on: {
      /////////// Slider ready event hdl. ////////////
      ////////////////////////////////////////////////

      // ready: () => {
      //   if (this.options.logs) console.log("Slider ready.");
      // },

      /////////// Slide change event hdl. ////////////
      ////////////////////////////////////////////////

      change: (i_activeSlide) => {
        // Pagination updt. //
        console.log("index_activeSlide", i_activeSlide);
        if (paginationDots) paginationDots.forEach((dot, i) => (dot.dataset.active = i === i_activeSlide ? "true" : "false"));
      },
    },
  });

  /////////// Ctrl. init. ////////////
  ////////////////////////////////////

  if (btn_prev) btn_prev.addEventListener("click", () => inst_flkty.previous());
  if (btn_next) btn_next.addEventListener("click", () => inst_flkty.next());

  ///////////// Conclude /////////////
  ////////////////////////////////////

  if (logs) console.log(msgs.end[0], "→", msgs.end[1]);
}
